// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthLink_root_1aPwA"};